export const INGREDIENT = 'ingredient';
export const FIRST_LETTER = 'firstLetter';
export const NAME = 'name';
